import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function IOLevels({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="View I/O Levels"
      fullCaption="Channel A Type.............MAO1........
      Channel A Value............0.0f...........
      Channel B Type.............MAO2........
      Channel B Value............0.0f.............
      Channel C Type.............FO1............
      Channel C Value............0.0f.............
      "
    />
  );
}

export default IOLevels;
